import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Text, Icon, Label } from '@fluentui/react';
import classNames from 'classnames';
import { NeutralColors } from '@fluentui/theme';
export const RatingsInfo = ({ avgRating, ratingsCount, key, title, context, textSize, starClass, ratingClass })=>{
    const styles = {
        root: [
            'detailsRatingStar',
            textSize ? {
                fontSize: 13,
                margin: '0 4px 0 0'
            } : {
                fontSize: 16,
                margin: '0 4px 3px 0'
            },
            !ratingsCount && {
                color: NeutralColors.gray90
            }
        ]
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "ratingInfoSection",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                iconName: ratingsCount ? 'FavoriteStarFill' : 'FavoriteStar',
                title: title || context.loc('RatingSummary_Title', 'Marketplace ratings'),
                styles: styles
            }),
            /*#__PURE__*/ _jsx(Label, {
                className: classNames([
                    starClass || 'detailsRatingAvgNumOfStars'
                ]),
                children: avgRating.toFixed(1)
            }),
            /*#__PURE__*/ _jsxs(Text, {
                className: classNames([
                    ratingClass || 'detailsRatingNumOfRatingText'
                ]),
                variant: textSize || 'medium',
                children: [
                    "(",
                    ratingsCount,
                    " ",
                    title,
                    ")"
                ]
            })
        ]
    }, `${key}DetailsRating`);
};
